function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.442 17.1275L8.32759 5.30345C8.14996 5.20398 7.9462 5.16109 7.74354 5.18052C7.54089 5.19996 7.34899 5.28078 7.1935 5.41219C7.03801 5.5436 6.92633 5.71935 6.87339 5.91593C6.82045 6.11251 6.82877 6.32057 6.89725 6.51229L10.8799 17.6637C10.9576 17.8812 10.9576 18.1188 10.8799 18.3363L6.89725 29.4877C6.82877 29.6794 6.82045 29.8875 6.87339 30.0841C6.92633 30.2807 7.03801 30.4564 7.1935 30.5878C7.34899 30.7192 7.54089 30.8 7.74355 30.8195C7.9462 30.8389 8.14996 30.796 8.32759 30.6965L29.442 18.8725C29.597 18.7857 29.7262 18.659 29.8161 18.5057C29.906 18.3523 29.9533 18.1778 29.9533 18C29.9533 17.8222 29.906 17.6477 29.8161 17.4943C29.7262 17.341 29.597 17.2144 29.442 17.1275V17.1275Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 18H19",
  stroke: "url(#paint1_linear)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 33.1316,
  y1: 1.00814,
  x2: 0.89232,
  y2: 30.3502,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.166653,
  stopColor: "#FBAE17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572457,
  stopColor: "#EF4E23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.829771,
  stopColor: "#C3161C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#432A74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 20.1,
  y1: 17.8375,
  x2: 19.7922,
  y2: 20.3245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.166653,
  stopColor: "#FBAE17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572457,
  stopColor: "#EF4E23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.829771,
  stopColor: "#C3161C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#432A74"
})));

var SvgSendChat = function SvgSendChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sendChat.6851a04e.svg";
export { ForwardRef as ReactComponent };